import { LocalTrack, Room, LocalVideoTrack, Track } from 'livekit-client';

import { logger } from '@gem/modules/logger';

export class LiveKitShareScreenProvider {
  private localScreenTrack: LocalTrack | null = null;
  private providerUrl: string;
  isJoined = false;
  room: Room;
  channelId: string;

  constructor(providerUrl: string) {
    this.providerUrl = providerUrl;
    this.room = new Room();
  }

  async join(params: { token: string; channelId: string }): Promise<void> {
    const { token } = params;

    try {
      await this.room.connect(this.providerUrl, token);
      // after connect we are getting current opponents from call
      this.isJoined = true;
    } catch (e) {
      logger.get('CallProviders').error('LiveKit.join', e);
    }
  }

  async createScreenSharingTrack(track?: MediaStreamTrack): Promise<LocalTrack | null> {
    if (track) {
      const screenVideo = new LocalVideoTrack(track, undefined, false);
      screenVideo.source = Track.Source.ScreenShare;
      return screenVideo;
    }
    const tracks = await this.room.localParticipant.createScreenTracks();
    return tracks[0];
  }

  async startScreenSharing(params: {
    electronSourceId?: string;
    onEnded?: () => void;
    needToPublish?: boolean;
    track?: MediaStreamTrack;
  }): Promise<boolean> {
    if (!this.isJoined) {
      return false;
    }

    try {
      const track = await this.createScreenSharingTrack(params.track);

      if (!track) {
        return false;
      }

      if (params.onEnded) {
        track.on('ended', params.onEnded);
      }

      if (params.needToPublish) {
        await this.room.localParticipant.publishTrack(track);
      }

      this.localScreenTrack = track;

      return true;
    } catch (e) {
      await this.stopScreenShare();
      logger.get('CallProviders').error('LivekitScreenShareProvider.startScreenSharing', e);

      return false;
    }
  }

  async stopScreenShare(): Promise<void> {
    if (this.localScreenTrack) {
      if (this.isJoined) {
        await this.room.localParticipant.unpublishTrack(this.localScreenTrack);
      }
      this.localScreenTrack.stop();
      this.localScreenTrack = null;
    }
    if (this.isJoined) {
      await this.room.disconnect(true);
      this.isJoined = false;
    }
  }
}
